"use strict";
/******************************************************************
 * Copyright @ 2023 广州牛师帮文化科技有限公司. All rights reserverd.
 * @file   src\phone\index.ts
 * @author 朱剑豪
 * @date   2023/01/06 11:15
 * @desc   手机号码相关工具
 ******************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPhoneValid = exports.AREA_CODES = exports.AREA_CODE_LABELS = exports.AREA_CODE_VALUES = exports.Phone = void 0;
var Phone;
(function (Phone) {
    /**
      * 地区编码值数组
      */
    Phone.AREA_CODE_VALUES = ['86', '852', '853', '886', '65'];
    /**
      * 地区编码文本数组
      */
    Phone.AREA_CODE_LABELS = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '86': '+86',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '852': '+852',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '853': '+853',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '886': '+886',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '65': '+65',
    };
    /**
      * 地区编码值与文本数组
      */
    Phone.AREA_CODES = Phone.AREA_CODE_VALUES.map(function (value) { return ({ value: value, label: Phone.AREA_CODE_LABELS[value] }); });
    /**
     * isValid
     *      手机号码校验
     *
     * @param areaCode  地区编码
     * @param phone 手机号
     * @return 手机号合法时，返回true否则返回false
     */
    function isValid(areaCode, phone) {
        if (typeof areaCode !== 'string' || typeof phone !== 'string') {
            return false;
        }
        // 均移除两边空白
        areaCode = areaCode.trim();
        phone = phone.trim();
        // 根据地区编码选择正则表达式
        var regex;
        switch (areaCode) {
            case '+86':
            case '86':
                regex = /^[1]\d{10}$/;
                break;
            case '+852':
            case '852':
                regex = /^(5|6|8|9)\d{7}$/;
                break;
            case '+853':
            case '853':
                regex = /^[6](8|6)\d{6}$/;
                break;
            case '+886':
            case '886':
                regex = /^[0][9]\d{8}$/;
                break;
            case '+65':
            case '65':
                regex = /^(6|8|9)\d{7}$/;
                break;
            default:
                return false; // 不支持其他
        }
        return regex.test(phone);
    }
    Phone.isValid = isValid;
    /**
     * 筛子函数，分离出合法项、不合法项、异常项
     * @param phones [区号，电话号]数组
     * @returns SieveResult
     */
    function sieve(phones) {
        var validPhones = [];
        var invalidPhones = [];
        var errorPhones = [];
        if (Array.isArray(phones)) {
            for (var i = 0; i < phones.length; ++i) {
                var phone = phones[i];
                if (!Array.isArray(phone) || phone.length < 2) {
                    errorPhones.push(phone);
                    continue;
                }
                (isValid(phone[0], phone[1]) ? validPhones : invalidPhones).push(phone);
            }
        }
        return { validPhones: validPhones, invalidPhones: invalidPhones, errorPhones: errorPhones };
    }
    Phone.sieve = sieve;
    ;
})(Phone = exports.Phone || (exports.Phone = {}));
/**
 * @deprecated use Phone.AREA_CODE_VALUES
 */
exports.AREA_CODE_VALUES = Phone.AREA_CODE_VALUES;
/**
 * @deprecated use Phone.AREA_CODE_LABELS
 */
exports.AREA_CODE_LABELS = Phone.AREA_CODE_LABELS;
/**
 * @deprecated use Phone.AREA_CODES
 */
exports.AREA_CODES = Phone.AREA_CODES;
/**
 * @deprecated use Phone.isValid
 */
exports.isPhoneValid = Phone.isValid;
//# sourceMappingURL=index.js.map